import { createPathFromRoute } from 'assets/utils/dom/UrlParsing';
import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Core.Draft.List.IRequest;
type Response = Api.Core.Draft.List.IResponse;
type Headers = Api.Core.Draft.List.IHeaders;
const url = '/api/Draft/:entity';
export default async function draftListApi({ entity, ...body }: Request): Promise<Api.Res<Response>> {
  return await executeServerApi<Omit<Request, 'entity'>, Response, Headers>({
    method: HttpMethod.get,
    url: createPathFromRoute(url, { entity }),
    body,
    headers: getDefaultHeaders(),
  });
}
